import { poll } from 'lib/poll';
import { MutationCreateSoftAmendmentArgs, createSoftAmendment, getAmendment, acceptAmendment } from 'lib/graphql';
import { GraphQLClient } from 'types';
import { millisecond } from 'config/constants';

export const processSoftAmendment = async (client: GraphQLClient, { bookingId, input }: MutationCreateSoftAmendmentArgs) => {
  const createResult = await createSoftAmendment(client, { variables: { bookingId, input } });
  const amendmentId = createResult.data?.createSoftAmendment.id;

  if (!amendmentId) {
    throw new Error('Failed creating amendment');
  }

  const quotedResult = await poll({
    requestFn: () => getAmendment(client, { variables: { bookingId, amendmentId }, fetchPolicy: 'network-only' }),
    isFinished: (result) => result.data.amendment.state !== 'QUOTING',
    timeoutMs: millisecond.MINUTE,
  });

  if (quotedResult.data.amendment.state !== 'QUOTED') {
    throw new Error(`Expected amendment to be "QUOTED" but state was "${quotedResult.data.amendment.state}"`);
  }

  if (quotedResult.data.amendment.amendmentTotal?.type !== 'NO_PAYMENT') {
    throw new Error(`Expected non financial amendment`);
  }

  await acceptAmendment(client, { variables: { bookingId, amendmentId } });

  const acceptedResult = await poll({
    requestFn: () => getAmendment(client, { variables: { bookingId, amendmentId }, fetchPolicy: 'network-only' }),
    isFinished: (result) => result.data.amendment.state !== 'ACCEPTING',
    timeoutMs: millisecond.MINUTE,
  });

  if (acceptedResult.data.amendment.state !== 'ACCEPTED') {
    throw new Error(`Expected amendment to be "ACCEPTED" but state was "${acceptedResult.data.amendment.state}"`);
  }

  return acceptedResult.data.amendment;
};
